class AAProductStory {
  constructor(section) {
    this.section = section;
    this.rail = section.querySelector("[data-aa-story-rail]");
    this.cards = Array.from(section.querySelectorAll("[data-aa-story-open]"));
    this.modal = section.querySelector("[data-aa-story-modal]");
    this.modalBody = section.querySelector("[data-aa-story-body]");
    this.buyButton = section.querySelector("[data-aa-story-buy]");
    this.buyButtonText = section.querySelector(".aa-story-modal__cta-text");
    this.dialog = section.querySelector(".aa-story-modal__dialog");
    this.modalPrev = section.querySelector("[data-aa-story-modal-prev]");
    this.modalNext = section.querySelector("[data-aa-story-modal-next]");
    this.currentIndex = -1;
    this.preloadedMedia = new Set();

    if (!this.rail || !this.modal || !this.modalBody || !this.buyButton || !this.cards.length) return;

    this.bindRailNav();
    this.bindCards();
    this.bindModal();
  }

  bindRailNav() {
    const prev = this.section.querySelector("[data-aa-story-prev]");
    const next = this.section.querySelector("[data-aa-story-next]");
    if (prev) {
      prev.addEventListener("click", () => {
        this.scrollRail(-1);
      });
    }
    if (next) {
      next.addEventListener("click", () => {
        this.scrollRail(1);
      });
    }
  }

  bindCards() {
    this.cards.forEach((button, index) => {
      button.addEventListener("click", () => {
        this.currentIndex = index;
        this.activeOpener = button;
        this.renderCurrentItem();
        this.openModal();
      });
    });
  }

  buildModalContent(button) {
    const imageUrl = button.dataset.aaStoryImage;
    const imageAlt = button.dataset.aaStoryImageAlt || button.dataset.aaStoryCaption || "";
    if (imageUrl) {
      return `
        <div class="aa-story-modal__stage aa-story-modal__stage--image">
          <img
            src="${imageUrl}"
            alt="${this.escapeHtml(imageAlt)}"
            loading="eager"
            decoding="async"
            class="aa-story-modal__img"
          >
        </div>
      `;
    }

    const template = button.parentElement.querySelector("[data-aa-story-template]");
    return template ? template.innerHTML : "";
  }

  bindModal() {
    this.section.querySelectorAll("[data-aa-story-close]").forEach((button) => {
      button.addEventListener("click", () => this.closeModal());
    });

    if (this.modalPrev) {
      this.modalPrev.addEventListener("click", () => this.goToItem(-1));
    }

    if (this.modalNext) {
      this.modalNext.addEventListener("click", () => this.goToItem(1));
    }

    this.buyButton.addEventListener("click", () => {
      this.handleBuy();
    });

    document.addEventListener("keydown", (event) => {
      if (this.modal.hidden) return;

      if (event.key === "Escape") {
        this.closeModal();
        return;
      }

      if (event.key === "ArrowLeft") {
        event.preventDefault();
        this.goToItem(-1);
      }

      if (event.key === "ArrowRight") {
        event.preventDefault();
        this.goToItem(1);
      }
    });
  }

  scrollRail(direction) {
    const scrollAmount = Math.round(this.rail.clientWidth * 0.82);
    this.rail.scrollBy({
      left: direction * scrollAmount,
      behavior: "smooth",
    });
  }

  openModal() {
    this.modal.hidden = false;
    this.modal.offsetHeight;
    if (this.activeOpener) {
      this.activeOpener.classList.add("is-story-active");
    }
    this.updateModalNav();
    document.documentElement.classList.add("aa-story-modal-open");
    document.body.classList.add("aa-story-modal-open");
    this.modal.classList.add("is-visible");
    this.syncModalMediaState();
    this.autoplayModalMedia();
    this.dialog.focus({ preventScroll: true });
  }

  closeModal() {
    this.pauseModalMedia();
    this.modal.classList.remove("is-visible");
    window.setTimeout(() => {
      this.modal.hidden = true;
      this.modalBody.innerHTML = "";
      this.currentIndex = -1;
      this.modal.classList.remove("is-video");
      document.documentElement.classList.remove("aa-story-modal-open");
      document.body.classList.remove("aa-story-modal-open");
      if (this.activeOpener) {
        this.activeOpener.classList.remove("is-story-active");
        this.activeOpener.focus({ preventScroll: true });
      }
    }, 220);
  }

  pauseModalMedia() {
    this.modalBody.querySelectorAll("video").forEach((video) => {
      try {
        video.pause();
      } catch (error) {
        // no-op
      }
    });
  }

  handleBuy() {
    this.closeModal();

    const productSection = document.querySelector(".cc-main-product .js-product");
    if (!productSection) return;

    const variantsAnchor = document.getElementById("variants");
    const addToCartButton = productSection.querySelector(".btn--pdp-atc");

    if (variantsAnchor) {
      variantsAnchor.scrollIntoView({ behavior: "smooth", block: "center" });
    } else if (addToCartButton) {
      addToCartButton.scrollIntoView({ behavior: "smooth", block: "center" });
    }

    window.setTimeout(() => {
      if (addToCartButton) {
        addToCartButton.click();
      }
    }, 320);
  }

  renderCurrentItem() {
    const button = this.cards[this.currentIndex];
    if (!button) return;

    this.section.querySelectorAll(".is-story-active").forEach((item) => {
      item.classList.remove("is-story-active");
    });

    this.activeOpener = button;
    this.activeOpener.classList.add("is-story-active");
    this.modalBody.innerHTML = this.buildModalContent(button);
    this.setBuyLabel(button.dataset.aaStoryBuyLabel);
    this.syncModalMediaState();
    if (!this.modal.hidden) {
      this.autoplayModalMedia();
    }
    this.updateModalNav();
    this.preloadAdjacentItems();
  }

  goToItem(direction) {
    if (!this.cards.length) return;

    const nextIndex = this.currentIndex + direction;
    if (nextIndex < 0 || nextIndex >= this.cards.length) return;

    this.pauseModalMedia();
    this.currentIndex = nextIndex;
    this.renderCurrentItem();
  }

  updateModalNav() {
    const hasMultipleItems = this.cards.length > 1;
    if (this.modalPrev) {
      this.modalPrev.disabled = !hasMultipleItems || this.currentIndex <= 0;
    }
    if (this.modalNext) {
      this.modalNext.disabled = !hasMultipleItems || this.currentIndex >= this.cards.length - 1;
    }
  }

  syncModalMediaState() {
    const hasVideo = Boolean(this.modalBody.querySelector("video, iframe"));
    this.modal.classList.toggle("is-video", hasVideo);
  }

  autoplayModalMedia() {
    const video = this.modalBody.querySelector("video");
    if (!video) return;

    video.muted = true;
    video.setAttribute("muted", "");
    video.setAttribute("autoplay", "");
    video.playsInline = true;

    const playPromise = video.play();
    if (playPromise && typeof playPromise.catch === "function") {
      playPromise.catch(() => {
        // no-op
      });
    }
  }

  preloadAdjacentItems() {
    [this.currentIndex - 1, this.currentIndex + 1].forEach((index) => {
      if (index < 0 || index >= this.cards.length) return;
      this.preloadCardMedia(this.cards[index]);
    });
  }

  preloadCardMedia(button) {
    if (!button) return;

    const imageUrl = button.dataset.aaStoryImage;
    if (imageUrl) {
      this.preloadImage(imageUrl);
      return;
    }

    const template = button.parentElement.querySelector("[data-aa-story-template]");
    if (!template) return;

    const probe = document.createElement("div");
    probe.innerHTML = template.innerHTML;

    probe.querySelectorAll("img").forEach((img) => {
      this.preloadImage(img.getAttribute("src"));
    });

    const video = probe.querySelector("video");
    if (video) {
      const videoSrc =
        video.getAttribute("src") ||
        video.querySelector("source")?.getAttribute("src");
      this.preloadVideo(videoSrc);
    }
  }

  preloadImage(src) {
    if (!src || this.preloadedMedia.has(src)) return;
    this.preloadedMedia.add(src);

    const image = new Image();
    image.decoding = "async";
    image.src = src;
  }

  preloadVideo(src) {
    if (!src || this.preloadedMedia.has(src)) return;
    this.preloadedMedia.add(src);

    const video = document.createElement("video");
    video.preload = "metadata";
    video.muted = true;
    video.playsInline = true;
    video.src = src;
    video.load();
  }

  setBuyLabel(label) {
    if (!label) return;

    if (this.buyButtonText) {
      this.buyButtonText.textContent = label;
      this.buyButton.setAttribute("aria-label", label);
      return;
    }

    this.buyButton.textContent = label;
  }

  escapeHtml(value) {
    return String(value)
      .replace(/&/g, "&amp;")
      .replace(/"/g, "&quot;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;");
  }
}

const scrollToProductEditorial = (hash = "#product-editorial") => {
  if (!hash || !hash.includes("#product-editorial")) return false;

  const anchor =
    document.querySelector("[data-editorial-anchor]") ||
    document.getElementById("product-editorial");
  if (!anchor) return false;

  const top = anchor.getBoundingClientRect().top + window.scrollY - 96;
  window.scrollTo({
    top: Math.max(top, 0),
    behavior: "smooth",
  });
  return true;
};

const initAAProductStories = (scope = document) => {
  scope.querySelectorAll("[data-aa-story-section]").forEach((section) => {
    if (section.dataset.aaStoryReady === "true") return;
    section.dataset.aaStoryReady = "true";
    new AAProductStory(section);
  });
};

const bootAAProductStories = () => {
  initAAProductStories(document);
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", bootAAProductStories);
} else {
  bootAAProductStories();
}

window.addEventListener("load", bootAAProductStories);
window.addEventListener("pageshow", bootAAProductStories);

document.addEventListener("click", (event) => {
  const trigger = event.target.closest(
    'a[href*="#product-editorial"], button[data-scroll-to-editorial], [data-scroll-to-editorial]'
  );
  if (!trigger) return;

  const href = trigger.getAttribute("href") || "#product-editorial";
  const isSamePageLink =
    !trigger.href ||
    trigger.href.split("#")[0] === window.location.href.split("#")[0];

  if (isSamePageLink && scrollToProductEditorial(href)) {
    event.preventDefault();
    event.stopPropagation();
    if (window.history?.replaceState) {
      window.history.replaceState(null, "", "#product-editorial");
    }
  }
});

window.addEventListener("load", () => {
  if (window.location.hash === "#product-editorial") {
    window.setTimeout(() => {
      scrollToProductEditorial(window.location.hash);
    }, 120);
  }
});

window.addEventListener("hashchange", () => {
  if (window.location.hash === "#product-editorial") {
    scrollToProductEditorial(window.location.hash);
  }
});

document.addEventListener("shopify:section:load", (event) => {
  initAAProductStories(event.target);
});

window.initAAProductStories = initAAProductStories;

if ("MutationObserver" in window) {
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof HTMLElement)) return;
        if (node.matches?.("[data-aa-story-section]")) {
          initAAProductStories(node.parentNode || document);
          return;
        }
        if (node.querySelector?.("[data-aa-story-section]")) {
          initAAProductStories(node);
        }
      });
    }
  });

  const startObserving = () => {
    if (!document.body) return;
    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", startObserving, { once: true });
  } else {
    startObserving();
  }
}
